var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendTokenOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_1173_4480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.84766 2.41503L1.64633 8.61636C0.0998578 10.1628 0.0998582 12.6702 1.64633 14.2166L7.84766 20.418C9.39414 21.9644 11.9015 21.9644 13.4479 20.418L19.6493 14.2166C21.1957 12.6702 21.1957 10.1628 19.6493 8.61636L13.4479 2.41503C11.9015 0.868556 9.39413 0.868557 7.84766 2.41503Z",
    fill: "white",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1396 9.4165L10.6496 4.92651L6.16965 9.41651",
    stroke: "#76808D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6494 4.92649L10.6494 17.9065",
    stroke: "#76808D",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1173_4480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.32,
    height: 21.32,
    fill: "white",
    transform: "translate(-0.000488281 0.75647)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendTokenOutline);
export default __webpack_public_path__ + "static/media/sendTokenOutline.067cc0e228c0b1fec8be023c73d7e924.svg";
export { ForwardRef as ReactComponent };